import { Tab, Tabs } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  root: { minWidth: 0, overflowX: 'hidden' },
  // The tab strip doubles as the page title, so a step larger than Alfred's
  // usual 14px tabs.
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(1),
    minHeight: 56
  },
  tab: {
    minWidth: 'auto',
    // MUI caps a tab at 264px and wraps the label; a long one
    // ("Cancelled & rescheduled") read as two stacked lines (owner, 2026-10-19).
    maxWidth: 'none',
    whiteSpace: 'nowrap',
    minHeight: 56,
    fontSize: 16,
    letterSpacing: 0.4,
    padding: theme.spacing(1.5, 3),
    '&.Mui-selected': { fontWeight: 700 }
  }
}))

/**
 * An At Home page: a row of tabs across the top of the content area, the
 * chosen one remembered per page. The left panel picks the page (Schedules
 * listed / Bookings / Attended / Issues / Setup); these tabs pick the view
 * inside it (Trial / Regular / Past, or Categories / Apartments).
 */
const TabbedPage = ({ storageKey, tabs }) => {
  const classes = useStyles()
  const [tab, setTab] = React.useState(() => {
    const saved = window.localStorage.getItem(storageKey)
    return tabs.some((t) => t.id === saved) ? saved : tabs[0].id
  })
  React.useEffect(() => {
    window.localStorage.setItem(storageKey, tab)
  }, [storageKey, tab])

  const active = tabs.find((t) => t.id === tab) || tabs[0]
  return (
    <div className={classes.root}>
      <Tabs
        className={classes.tabs}
        value={active.id}
        onChange={(e, v) => setTab(v)}
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((t) => (
          <Tab
            key={t.id}
            value={t.id}
            label={t.label}
            className={classes.tab}
          />
        ))}
      </Tabs>
      {active.render()}
    </div>
  )
}

TabbedPage.propTypes = {
  storageKey: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      render: PropTypes.func.isRequired
    })
  ).isRequired
}

export default TabbedPage
